class BeforeAfterOctopus {
  constructor(element) {
    this.element = element;
    this.svgBefore = element.querySelector("[data-before-octopus]");
    this.svgAfter = element.querySelector("[data-after-octopus]");
    this.windowHeight = window.innerHeight;

    this.addScrollListener();
  }

  addScrollListener() {
    window.addEventListener("scroll", this.throttle(this.handleScroll, 100));
  }

  throttle(func, limit) {
    let lastFunc;
    let lastRan;
    return function (...args) {
      if (!lastRan) {
        func.apply(this, args);
        lastRan = Date.now();
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(() => {
          if (Date.now() - lastRan >= limit) {
            func.apply(this, args);
            lastRan = Date.now();
          }
        }, limit - (Date.now() - lastRan));
      }
    };
  }

  handleScroll = () => {
    if (!this.isVisible()) {
      this.deactivateAll();
    } else {
      this.updateVisibility();
    }
  };

  isVisible = () => {
    const { top, bottom } = this.element.getBoundingClientRect();
    return top <= this.windowHeight && bottom >= 0;
  };

  updateVisibility = () => {
    const beforeHalfVisible = this.isHalfVisible(this.svgBefore);
    const afterVisible = this.isFullyVisible(this.svgAfter);

    if (beforeHalfVisible) {
      this.activate(this.svgBefore);
      this.deactivate(this.svgAfter);
    } else if (afterVisible) {
      this.deactivate(this.svgBefore);
      this.activate(this.svgAfter);
    } else {
      this.deactivateAll();
    }
  };

  isHalfVisible = (el) => {
    const { top, bottom } = el.getBoundingClientRect();
    return top <= this.windowHeight / 3 && bottom > this.windowHeight / 2;
  };

  isFullyVisible = (el) => {
    const { top } = el.getBoundingClientRect();
    return top < this.windowHeight / 3;
  };

  deactivateAll = () => {
    this.deactivate(this.svgBefore);
    this.deactivate(this.svgAfter);
  };

  activate(el) {
    el.classList.add("is-active");
  }

  deactivate(el) {
    el.classList.remove("is-active");
  }
}

document.querySelectorAll("[data-before-after-octopus]").forEach((element) => {
  new BeforeAfterOctopus(element);
});
